import { CommentSharp } from '@mui/icons-material';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const referralTeamSales = {
    id: 'followUpReport',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'followUpReport',
            title: 'Follow Up Report',
            type: 'item',
            url: '/followUpReport',
            icon: CommentSharp,
            breadcrumbs: false
        }
    ]
};

export default referralTeamSales;
